module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADsSURBVHgBhVJbbsIwEJxdg9MipepD/c9HK/UY4Sg9QE/TA3AUcgw+EMoBEEEgQUKwjdcIFAiQkSzZ2pmxd9aEKzz9pykDqewtkJV/WdasU5NIRCMV64QGGqQIdl35tcutc78nIZ3Iqq/G+usdHEcXN5rlFvWsgNnboYg4qLxzP3lrkQXq9Rn6+wPsOYEr7r2XaBz9fOIRqskc+1U5ZGnwlvM1eNBD4MrBGdcpgOKjUKJzm7qT79MKMbN0btZVblfVXbIpthJxfk7J+Zx304UvlG2yN6rzAjILOd8YXJRwrENf8lRxbg2uia6vcQAKDHdYhTYiswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/wait.png
// module id = 1535
// module chunks = 0